import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ spacing }) =>
  createStyles({
    main: {
      padding: spacing(3),
    },
    tabs: {
      margin: spacing(2, 0),
      '& .MuiTabs-indicator': {
        display: 'none',
      },
      '& .Mui-selected': {
        fontWeight: 'bold',
        textDecoration: 'none',
      },
      '& .MuiTabs-flexContainer': {
        '& > button:last-child': {
          borderLeft: '2px solid #e0e0e0',
        },
      },
    },
  }),
)
